import { render, staticRenderFns } from "./LayaFooter.vue?vue&type=template&id=5a9d5334"
import script from "./LayaFooter.vue?vue&type=script&lang=js"
export * from "./LayaFooter.vue?vue&type=script&lang=js"
import style0 from "./LayaFooter.vue?vue&type=style&index=0&id=5a9d5334&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports